import { useList } from './List.h'
import { usePermission } from '@shared/hooks/permissions'

import Typography from '@mui/material/Typography'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import LinearProgress from '@mui/material/LinearProgress'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import MoreVertIcon from '@mui/icons-material/MoreVert'

export default function Data() {
    const {
        query,
        anchor,
        setAnchor,
        setInstance,

        handleDelete,
        handleFetchInstance
    } = useList()
    const { hasPermission } = usePermission()

    return query.isLoading
        ? <LinearProgress />
        : query.error
            ? <Typography className='centerized'>حدث خطأ</Typography>
            : (
                <>
                    {query.data.length == 0 ? (
                        <Typography className='centerized'>
                            لا توجد بيانات
                        </Typography>
                    ) : (
                        <List>
                            {query.data.map(user =>
                                <ListItem
                                    key={user.id}
                                    disablePadding
                                    secondaryAction={(hasPermission('change_user') && hasPermission('delete_user')) &&
                                        <IconButton onClick={e => setAnchor(e.currentTarget)}>
                                            <MoreVertIcon />
                                        </IconButton>
                                    }
                                    onClick={() => setInstance(user)}
                                >
                                    <ListItemButton>
                                        <ListItemText
                                            primary={`${user.first_name} ${user.last_name}`}
                                            secondary={user.job_name}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            )}
                        </List>
                    )}
                    {(hasPermission('change_user') && hasPermission('delete_user')) &&
                        <Menu
                            open={!!anchor}
                            anchorEl={anchor}
                            onClose={() => setAnchor(null)}
                        >
                            {hasPermission('change_user') && <MenuItem onClick={handleFetchInstance}>تعديل</MenuItem>}
                            {hasPermission('delete_user') && <MenuItem onClick={handleDelete}>حذف</MenuItem>}
                        </Menu>
                    }
                </>
            )
}